import { previewAudience } from '@/features/AudienceManager/services';
export const fetchPreviewAudience = (payload) => {
    return previewAudience(payload).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    const success = response?.success ?? false;
    const columns = Array.isArray(response?.columns) ? response.columns : [];
    const rows = Array.isArray(response?.data) ? response.data : [];
    return {
        success,
        columns: columns.map(column => ({
            key: column.key,
            dataKey: column.key,
            sortable: true,
            title: column.name,
            width: column.name.length > 15 ? 180 : 140,
        })),
        rows: normalizeRows(rows, columns),
    };
};
const normalizeRows = (rows, columns) => {
    return rows.map(row => columns.reduce((acc, col, index) => {
        return {
            ...acc,
            [col.key]: row[index] ?? '',
        };
    }, {}));
};
